import { render, staticRenderFns } from "./streamTv_Home.vue?vue&type=template&id=28c11b9e&"
import script from "./streamTv_Home.vue?vue&type=script&lang=js&"
export * from "./streamTv_Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports